/**
 * Outfit Combinations
 * Handles expand/collapse functionality for outfit combinations
 */

class OutfitCombinations {
  constructor() {
    this.init();
  }

  init() {
    // Handle expand/collapse buttons
    document.addEventListener('click', (e) => {
      const expandButton = e.target.closest('[data-action="expand"]');
      const collapseButton = e.target.closest('[data-action="collapse"]');

      if (expandButton) {
        this.expandCombination(expandButton);
      } else if (collapseButton) {
        this.collapseCombination(collapseButton);
      }
    });
  }

  /**
   * Expand outfit combination to show products
   */
  expandCombination(button) {
    const combination = button.closest('.outfit-combination');
    if (!combination) return;

    const collapsed = combination.querySelector('.outfit-combination__collapsed');
    const expanded = combination.querySelector('.outfit-combination__expanded');

    if (collapsed && expanded) {
      collapsed.style.display = 'none';
      expanded.style.display = 'block';

      // Scroll to the combination if needed
      setTimeout(() => {
        combination.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }

  /**
   * Collapse outfit combination to show main image
   */
  collapseCombination(button) {
    const combination = button.closest('.outfit-combination');
    if (!combination) return;

    const collapsed = combination.querySelector('.outfit-combination__collapsed');
    const expanded = combination.querySelector('.outfit-combination__expanded');

    if (collapsed && expanded) {
      collapsed.style.display = 'block';
      expanded.style.display = 'none';

      // Scroll to the combination if needed
      setTimeout(() => {
        combination.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OutfitCombinations();
  });
} else {
  new OutfitCombinations();
}
